<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'expo-info',
  components: {
    PageTable,
  },
}
</script>
